import PropTypes from 'prop-types';
// material-ui
import Box from '@mui/material/Box';

export default function Dot({ size, variant, sx }) {
return (
    <Box
      sx={{
        width: size || 8,
        height: size || 8,
        borderRadius: '50%',
        bgcolor: variant === 'outlined' ? '' : "#1677ff",
        ...(variant === 'outlined' && { border: "1px solid #1677ff" }),
        ...sx
      }}
    />
  );
}

Dot.propTypes = { size: PropTypes.number, variant: PropTypes.string, sx: PropTypes.any };
